import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";
import Loader from "../../../Components/Loader";
import CourierCountryServices from "../../../Services/CourierCountryServices";
import { MdDelete, MdEdit, MdVisibility } from "react-icons/md";
import Select from "react-select";
import {vendorService} from "../../../Services/vendorService"
import { ChangeStatus } from "../../../Components";
import { useLocation } from 'react-router-dom'
import CheckAccess from "../../../Function/CheckAccess";




const ProviderOption = [
  { value: "FEDEX", label: "Fedex" },
  { value: "UPS", label: "Ups" },
];

const serviceOption = [
  { value: "EXPORT", label: "EXPORT" },
  { value: "IMPORT", label: "IMPORT" },
];

// let ObjNum = [];
// for (let i = 0; i < 75; i++) {
//   ObjNum.push({ value: i, label: i });
// }
// const ZoneOption = ObjNum;

const ZoneOption = [
  { value: '', label: "All Zone" },
  { value: 1, label: "1" },
  { value: 2, label: "2" },
  { value: 3, label: "3" },
  { value: 4, label: "4" },
  { value: 5, label: "5" },
  { value: 6, label: "6" },
  { value: 7, label: "7" },
  { value: 8, label: "8" },
  { value: 9, label: "9" },
  { value: 10, label: "10" },
  { value: 11, label: "11" },
  { value: 12, label: "12" },
  { value: 13, label: "13" },
  { value: 14, label: "14" },
  { value: 15, label: "15" },
  { value: 16, label: "16" },
  { value: 17, label: "17" },
  { value: 18, label: "18" },
  { value: 19, label: "19" },
  { value: 20, label: "20" },
  { value: 21, label: "21" },
  { value: 22, label: "22" },
  { value: 23, label: "23" },
  { value: 24, label: "24" },
  { value: 25, label: "25" },
  { value: 26, label: "26" },
  { value: 27, label: "27" },
  { value: 28, label: "28" },
  { value: 29, label: "29" },
  { value: 30, label: "30" },
  { value: 31, label: "31" },
  { value: 32, label: "32" },
  { value: 33, label: "33" },
  { value: 34, label: "34" },
  { value: 35, label: "35" },
  { value: 36, label: "36" },
  { value: 37, label: "37" },
  { value: 38, label: "38" },
  { value: 39, label: "39" },
  { value: 40, label: "40" },
  { value: 41, label: "41" },
  { value: 42, label: "42" },
  { value: 43, label: "43" },
  { value: 44, label: "44" },
  { value: 45, label: "45" },
  { value: 46, label: "46" },
  { value: 47, label: "47" },
  { value: 48, label: "48" },
  { value: 49, label: "49" },
  { value: 50, label: "50" },
  { value: 51, label: "51" },
  { value: 52, label: "52" },
  { value: 53, label: "53" },
  { value: 54, label: "54" },
  { value: 55, label: "55" },
  { value: 56, label: "56" },
  { value: 57, label: "57" },
  { value: 58, label: "58" },
  { value: 59, label: "59" },
  { value: 60, label: "60" },
  { value: 61, label: "61" },
  { value: 62, label: "62" },
  { value: 63, label: "63" },
  { value: 64, label: "64" },
  { value: 65, label: "65" },
  { value: 66, label: "66" },
  { value: 67, label: "67" },
  { value: 68, label: "68" },
  { value: 69, label: "69" },
  { value: 70, label: "70" },
  { value: 71, label: "71" },
  { value: 72, label: "72" },
  { value: 73, label: "73" },
  { value: 74, label: "74" },
  { value: 75, label: "75" }
];

export const CourierCountryService = () => {
  const [countryList, setCountryList] = useState([]);
  const [serviceList, setServiceList] = useState();
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  // const [filterType, setFilterType] = useState();
  const [loader, setLoader] = useState(true);
  const [providerType, setProviderType] = useState({
    value: "",
    label: "",
  });
  const [serviceType, setServiceType] = useState({
    value: "",
    label: "",
  });

  
  const [zone, setZone] = useState({ value: '', label: '' })
  const [courierOptionlist, setCourierOptionlist] = useState()
  
  const history = useHistory();
  
    const location = useLocation()
  let user_type = localStorage.getItem("user_type")

  useEffect(() => {
    getCourierCountryList();
  }, []);

  const onselect = (e, type) => {
    if (type === "service") {
      setServiceType(e);
      getCourierCountryList(e.label, providerType.label, zone.value)
    }

    if (type === "provider") {
      setProviderType(e);
      getCourierCountryList(serviceType.value, e.label,  zone.value)
    }

    if(type === "zone"){
      setZone(e);
      getCourierCountryList(serviceType.value, providerType.label, e.value)
    }
  };

  useEffect(() => {
    const initialService = serviceOption.filter(
      (res) => res.value === "EXPORT"
    )[0];
    setServiceType({
      value: initialService.value,
      label: initialService.label,
    });

    const initialProvider = ProviderOption.filter(
      (res) => res.value === "FEDEX"
    )[0];
    setProviderType({
      value: initialProvider.value,
      label: initialProvider.label,
    });

    const initialzone = ZoneOption.filter(
      (res)=> res.label === "All Zone"
    )[0];

    setZone({
      value: initialzone.value,
      label: initialzone.label
    })

  }, []);



  const onDeleteModalSubmit = () => {
    let postData = {
      _id: isDeleteModalOpen._id
    };
    CourierCountryServices.deleteCourierCountryService(postData).then((res) => {
      if (res.status) {
        setIsDeleteModalOpen(false);
        getCourierCountryList();
      }
    });
  }

  useEffect(()=>{
    getVendorList();
  },[])

  const getVendorList = () => {
    vendorService.getVendor().then((res)=>{
      if(res.status === true){
        let arryVendor = []
        res.data.map(val=>{
          if(val.vendor_type === 'Courier')
          arryVendor.push({value: val._id, label: val.vendor_name})
          
        })
        setCourierOptionlist(arryVendor)
      }
    })
  }

  // const searchFilter = () => {
  //   setFilterType(!filterType);
  // };

  const getCourierCountryList = (service, provider, zones) => {

    let param = {
      service_type: service ? service : "EXPORT",
      service_provider: provider ? provider : "Fedex",
      zone: zones ? zones : ''
    };

    // if (zone.value) {
    //     param['zone'] = zone.value
    // }
    // if(serviceId){
    //   param['service_provider'] = serviceId.value
    // }

    // console.log('param===>', param)

    CourierCountryServices.getCouriercountryApi(param).then((res) => {
      if (res.status === true) {
        setCountryList(res.data);
        setLoader(false);
        // let arryService = []
        // res.data.map(list => {
        //     return arryService.push({value: list.service_provider, label: list.service_provider})
        // })
        // setServiceList(arryService);

        // console.log('res.data===>', res.data)
      } else {
        setLoader(false);
      }
    });
  };


  return (
    <div className="row">
      <div className="col-lg-12">
        <div className="card">
          <div className="card-body">
            <div className="d-flex  mb-3 justify-content-between">
              <div className="d-flex">
                <div className="me-3">
                  <Select
                    styles={{
                      valueContainer: (provided) => ({
                        ...provided,
                        height: "calc(2.15rem + 2px)",
                        overflowY: "visible",
                      }),
                      control: (provider) => ({
                        ...provider,
                        width: "200px",
                        boxShadow: "0 0 0 0px #f46a6a",
                      }),
                      placeholder: (provider) => ({
                        ...provider,
                        color: "#a0b0ca",
                      }),
                    }}
                    placeholder="Search with service..."
                    value={providerType}
                    onChange={(e) => onselect(e, "provider")}
                    options={courierOptionlist}
                  />
                </div>
                <div className="me-3">
                  <Select
                    styles={{
                      valueContainer: (provided) => ({
                        ...provided,
                        height: "calc(2.15rem + 2px)",
                        overflowY: "visible",
                      }),
                      control: (provider) => ({
                        ...provider,
                        width: "200px",
                        boxShadow: "0 0 0 0px #f46a6a",
                      }),
                      placeholder: (provider) => ({
                        ...provider,
                        color: "#a0b0ca",
                      }),
                    }}
                    placeholder="Search with type..."
                    value={serviceType}
                    onChange={(e) => onselect(e, "service")}
                    options={serviceOption}
                  />
                </div>

                <div>
                  <Select
                    styles={{
                      valueContainer: (provided) => ({
                        ...provided,
                        height: "calc(2.15rem + 2px)",
                        overflowY: "visible",
                      }),
                      control: (provider) => ({
                        ...provider,
                        width: "200px",
                        boxShadow: "0 0 0 0px #f46a6a",
                      }),
                      placeholder: (provider) => ({
                        ...provider,
                        color: "#a0b0ca",
                      }),
                    }}
                    isMulti={false}
                    onChange={(e) => onselect(e, "zone")}
                    placeholder="Select Zone"
                    value={zone}
                    options={ZoneOption}
                  />
                </div>

                {/* <button
                  className="btn btn-primary w-sm waves-effect waves-light ms-3"
                  onClick={() => searchFilter()}
                >
                  Search
                </button> */}
              </div>
              {
                (CheckAccess(33,"add")  ||  user_type === "SUPERADMIN" )&& 
              <button
                className="btn btn-primary w-sm waves-effect waves-light"
                onClick={() => history.push("/add-courier-country-service")}
              >
                Add Courier Country Service
              </button>
              }
            </div>
            <div className="table-responsive">
              <table class="table table-bordered table-nowrap mb-0">
                <thead>
                  <tr>
                    <th>Zone</th>
                    {/* <th>Type</th> */}
                    <th>Country</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody id="tbody">
                  {countryList &&
                    countryList.length > 0 &&
                    countryList.map((item, key) => {
                      return (
                        <tr key={key}>
                          <td>{item.zone}</td>
                          {/* <td>{item.service_type}</td> */}
                          <td>
                            <table>
                              <tbody>
                                <tr>
                                  <td
                                    style={{
                                      display: "flex",
                                      flexWrap: "wrap",
                                    }}
                                  >
                                    {item.countries.map((val) => {
                                      return (
                                        <div className="p-1 small border border-secondary">
                                          {val.country_name}
                                        </div>
                                      );
                                    })}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                          <td>
                            <MdVisibility
                              className="pointer me-2"
                              onClick={() =>
                                history.push(
                                  "/courier-country-service-details?id=" +
                                    item._id,
                                  item
                                )
                              }
                              color="#0323fe"
                              size="25px"
                            />
                            {
                               (CheckAccess(33,"edit") || user_type === "SUPERADMIN") &&  
                            <MdEdit
                              className="pointer"
                              onClick={() =>
                                history.push(
                                  "/edit-courier-country-service?id=" +
                                    item._id,
                                  item
                                )
                              }
                              color="#0323fe"
                              size="25px"
                            />
                            }

                          
                            {
                              (item?.countries.length < 2 &&  (CheckAccess(33,"delete")) ||  user_type === "SUPERADMIN") &&
                            <MdDelete   className="pointer"
                                color="red"
                                onClick={() => setIsDeleteModalOpen(item)}
                                size="25px"></MdDelete>
                            }
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>

              {countryList && countryList.length <= 0 && !loader && (
                <div className="text-center w-100 bg-warning my-5">
                  <h6 className="py-2"> No data available</h6>
                </div>
              )}

            </div>
          </div>
        </div>
        {Boolean(isDeleteModalOpen) && (
          <ChangeStatus
            isOpen={Boolean(isDeleteModalOpen)}
            title='Remove Country Service'
            message={`Are you sure want to remove Country Service ?`}
            onSubmitEvent={() => onDeleteModalSubmit()}
            handleClose={() => setIsDeleteModalOpen(false)}
          />
        )}
      </div>

      <Loader isShow={loader} />
    </div>
  );
};
